// extracted by mini-css-extract-plugin
module.exports = {"action":"action--2UujyM47QB","icon":"icon--2dS7hLy1E9"};